module.exports = __webpack_public_path__ + "static/homepage-1b2efd31df6fe596fc78cbd36c198087.png";